import React, { Component, createRef } from "react";
import TicketingCart from "../component/TicketingCart";
import TicketingFaq from "../component/TicketingFaq";
import TextField from "./../component/TextField";
import TextEditor from "../component/TextEditor";
import PlusIcon from "../icons/plusicon";
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
import Loader from "../component/loader";
//Validation import
import SimpleReactValidator from "simple-react-validator";
// Editors
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import ContactUs from "../component/ContactUs";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

let sub;

const SUBTITLE_TABS = [
  { name: 'In-person', value: 'inPersonSubtitle' },
  { name: 'Online', value: 'onlineSubtitle' },
  { name: 'Gala', value: 'galaSubtitle' },
  { name: 'FAQ', value: 'faqSubtitle' },
];

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};
export default class Ticketing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      activetab: 0,
      getTickitingDetails: [],
      getTickitingDocs: [],
      loaderFlag: false,
      headerTitle: "",
      inPersonSubtitle: EditorState.createEmpty(),
      footerSubtitle: EditorState.createEmpty(),
      ticket1: EditorState.createEmpty(),
      ticket2: EditorState.createEmpty(),
      ticket3: EditorState.createEmpty(),
      addToCartInPersonContent: EditorState.createEmpty(),
      addToCartOnlineContent: EditorState.createEmpty(),
      addToCartDisclaimer: EditorState.createEmpty(),
      onlineSubtitle: EditorState.createEmpty(),
      galaSubtitle: EditorState.createEmpty(),
      faqSubtitle: EditorState.createEmpty(),
      addToCartGalaContent: EditorState.createEmpty(),
      updatedAt: moment.utc().subtract(360, "minutes"),
      data: [
        {
          label: "Ticketing Home",
          Content: ""
        },
        {
          label: "Cart",
          Content: ""
        },
        {
          label: "FAQ",
          Content:""
        },
        {
          label: "Contact Us",
          Content: ""
        }
      ],
      selectedSubtitleTab: 'inPersonSubtitle',
      isticketingEdited: false,
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.childRef = createRef();
  }

  getCurrentFormData = () => {
      const normalizeDraftHtml = (editorState) => {
          if (!editorState || typeof editorState === 'string') return '';
          const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
          return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
      };

      return cloneDeep({
          headerTitle: this.state.headerTitle,
          inPersonSubtitle: normalizeDraftHtml(this.state.inPersonSubtitle),
          ticket1: normalizeDraftHtml(this.state.ticket1),
          ticket2: normalizeDraftHtml(this.state.ticket2),
          ticket3: normalizeDraftHtml(this.state.ticket3),
          onlineSubtitle: normalizeDraftHtml(this.state.onlineSubtitle),
          galaSubtitle: normalizeDraftHtml(this.state.galaSubtitle),
          faqSubtitle: normalizeDraftHtml(this.state.faqSubtitle),
          footerSubtitle: normalizeDraftHtml(this.state.footerSubtitle),
          addToCartInPersonContent: normalizeDraftHtml(this.state.addToCartInPersonContent),
          addToCartOnlineContent: normalizeDraftHtml(this.state.addToCartOnlineContent),
          addToCartDisclaimer: normalizeDraftHtml(this.state.addToCartDisclaimer),
          addToCartGalaContent: normalizeDraftHtml(this.state.addToCartGalaContent),
      });
  };

  markticketingEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isticketingEdited !== isDirty) {
        this.setState({ isticketingEdited: isDirty });
      }
    }
  };

  updateState = (newState, callback) => {
    this.setState(newState, () => {
      this.markticketingEdited();
      if (callback) callback();
    });
  };

  componentDidMount = async () => {
    this.getTickiting();
    this.getTickitingEvent();
    this.setState({
      loaderFlag: true
    });
  };

  componentWillUnmount() {
    if (sub) sub.unsubscribe();
  }

  getTickitingEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "ticketCms|ticketHome|getList":
          if (!response.error) {
            const fieldsToProcess = ['inPersonSubtitle', 'onlineSubtitle', 'galaSubtitle', 'faqSubtitle', 'ticket1', 'ticket2', 'ticket3', 'footerSubtitle', 'addToCartGalaContent', 'addToCartInPersonContent', 'addToCartOnlineContent', 'addToCartDisclaimer'];

            fieldsToProcess.forEach(field => {
              if (this.state[field]) {
                const fieldValue = response.data?.docs[0]?.[field] ?? '';
                const blocksFromHtml = htmlToDraft(fieldValue);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                const editorState = EditorState.createWithContent(contentState);
                this.setState({ [field]: editorState });
              }
            });

            this.setState({ loaderFlag: false });

            if(response.data.docs[0]){
              this.setState({
                getTickitingDocs: response.data,
                headerTitle: response.data.docs[0].headerTitle,
                id: response.data.docs[0]._id,
                fname: response.data.docs[0].updatedBy.fname,
                lname: response.data.docs[0].updatedBy.lname,
                updatedAt: moment.tz(response.data.docs[0].updatedAt, "US/Mountain"),
                loaderFlag: false
              }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isticketingEdited: false });
              });
            }else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });
          break;
        case "ticketCms|ticketHome|edit":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.setState({ isticketingEdited: false });
              this.apiserve.success("Ticketing updated successful.");
            });
            this.getTickiting();
          }
          break;
        case "ticketCms|ticketHome|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.setState({ isticketingEdited: false });
              this.apiserve.success("Ticketing Created successful.");
            });
          }
          break;
      }
    });
  };

  getTickiting = () => {
    this.apiserve.sendevent("ticketCms|ticketHome|getList", {});
  };
  onEditorStateChange = inPersonSubtitle => {
    this.updateState({ inPersonSubtitle });
  };
  onEditorStateChangeAddToCartGalaContent = addToCartGalaContent => {
    this.updateState({ addToCartGalaContent });
  };
  onEditorStateFooterSubtitleChange = footerSubtitle => {
    this.updateState({
      footerSubtitle
    });
  };
  onEditorStateChangeTickerOne = ticket1 => {
    this.updateState({
      ticket1
    });
  };
  onEditorStateChangeTickerTwo = ticket2 => {
    this.updateState({
      ticket2
    });
  };
  onEditorStateChangeTickerThree = ticket3 => {
    this.updateState({
      ticket3
    });
  };
  onSubtitleTabSelect = e => {
    this.setState({ selectedSubtitleTab: e.target.value });
  };

  onSubtitleEditorChange = editorState => {
    this.updateState({ [this.state.selectedSubtitleTab]: editorState });
  };
  onEditorStateChangeAddToCartInPersonContent = (addToCartInPersonContent) => {
    this.updateState({ addToCartInPersonContent });
  };
  onEditorStateChangeAddToCartOnlineContent = (addToCartOnlineContent) => {
    this.updateState({ addToCartOnlineContent });
  };
  onEditorStateChangeAddToCartDisclaimer = addToCartDisclaimer => {
    this.updateState({ addToCartDisclaimer });
  };

  handelChange = e => {
    this.updateState({
      [e.target.name]: e.target.value
    });
  };

  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.inPersonSubtitle.getCurrentContent());
      const markup = draftToHtml(name);
      const footerTitle = convertToRaw(this.state.footerSubtitle.getCurrentContent());
      const footerSubtitle = draftToHtml(footerTitle);
      const name1 = convertToRaw(this.state.ticket1.getCurrentContent());
      const markup1 = draftToHtml(name1);
      const name2 = convertToRaw(this.state.ticket2.getCurrentContent());
      const markup2 = draftToHtml(name2);
      const name3 = convertToRaw(this.state.ticket3.getCurrentContent());
      const markup3 = draftToHtml(name3);
      const addToCartInPersonContentRaw = convertToRaw(this.state.addToCartInPersonContent.getCurrentContent());
      const markupAddToCartInPersonContent = draftToHtml(addToCartInPersonContentRaw);
      const addToCartOnlineContentRaw = convertToRaw(this.state.addToCartOnlineContent.getCurrentContent());
      const markupAddToCartOnlineContent = draftToHtml(addToCartOnlineContentRaw);
      const addToCartDisclaimerRaw = convertToRaw(this.state.addToCartDisclaimer.getCurrentContent());
      const markupAddToCartDisclaimer = draftToHtml(addToCartDisclaimerRaw);
      const onlineRaw = convertToRaw(this.state.onlineSubtitle.getCurrentContent());
      const onlineHtml = draftToHtml(onlineRaw);
      const galaRaw = convertToRaw(this.state.galaSubtitle.getCurrentContent());
      const galaHtml = draftToHtml(galaRaw);
      const faqRaw = convertToRaw(this.state.faqSubtitle.getCurrentContent());
      const faqHtml = draftToHtml(faqRaw);
      const addToCartGalaContentRaw = convertToRaw(this.state.addToCartGalaContent.getCurrentContent());
      const addToCartGalaContentHtml = draftToHtml(addToCartGalaContentRaw);
      if(this.state.id){
        let updateTicket = {
          id: this.state.id,
          headerTitle: this.state.headerTitle,
          inPersonSubtitle: markup,
          ticket1: markup1,
          ticket2: markup2,
          ticket3: markup3,
          onlineSubtitle: onlineHtml,
          galaSubtitle: galaHtml,
          faqSubtitle: faqHtml,
          footerSubtitle: footerSubtitle,
          addToCartInPersonContent: markupAddToCartInPersonContent,
          addToCartOnlineContent: markupAddToCartOnlineContent,
          addToCartDisclaimer: markupAddToCartDisclaimer,
          addToCartGalaContent: addToCartGalaContentHtml,
        };
        this.apiserve.sendevent("ticketCms|ticketHome|edit", updateTicket);
      }else{
        let data = {
          headerTitle: this.state.headerTitle,
          inPersonSubtitle: markup,
          ticket1: markup1,
          ticket2: markup2,
          ticket3: markup3,
          addToCartInPersonContent: markupAddToCartInPersonContent,
          addToCartOnlineContent: markupAddToCartOnlineContent,
          addToCartDisclaimer: markupAddToCartDisclaimer,
          onlineSubtitle: onlineHtml,
          galaSubtitle: galaHtml,
          faqSubtitle: faqHtml,
          footerSubtitle:footerSubtitle,
          addToCartGalaContent: addToCartGalaContentHtml,
        }
        this.apiserve.sendevent("ticketCms|ticketHome|create", data);
      }
    }
    else{
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  TabClick = index => {
    this.setState({
      activetab: index
    });
  };
  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
  };

  AddQuestion = () => {
    if (this.childRef.current) {
      this.childRef.current.AddQuestion();
    }
  }

  render() {
    const { updatedAt } = this.state;
    var updatedBy = `${this.state.fname ? this.state.fname : ""} ${this.state.lname ? this.state.lname : ""}`;
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex small_list_tab">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li
                    className={this.state.activetab === index ? "active" : ""}
                    onClick={() => this.TabClick(index)}
                  >
                    <p className="uppercase">
                      <div style={{width:(list.label === 'FAQ' && this.state.activetab === index) ? 'calc(100% - 58px)' : '100%'}}>{list.label}</div>
                      {(list.label === 'FAQ' && this.state.activetab === index) && <span className="add_icon d_flex" onClick={this.AddQuestion}>
                        <PlusIcon />
                      </span>}
                    </p>
                  </li>
                );
              })}
          </ul>

          {this.state.activetab === 0 ? (
            <>
              <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                <p></p>
                <p className="update_date">
                  Last Update: {updatedAt.format("hh:mm A")} MT -{updatedAt.format("MM/DD/YYYY")} Last Updated
                  By: {updatedBy ? updatedBy : ""}
                </p>
              </div>
              <div className="ticketing_content fpg_tabcontent">
                <div className="ticketing_wrapper">
                  <form className="d_flex" style={{gap:'30px'}}>
                    <div className="" style={{flex: '1 1'}}>
                      <div className="field_row horizontal_field">
                        <TextField
                          type="text"
                          label="Header Title"
                          name="headerTitle"
                          value={this.state.headerTitle}
                          onChange={this.handelChange}
                          fpgerror={this.validator.message('headerTitle', this.state.headerTitle, 'required')}
                        />
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Tab Subtitle</label>
                          <div className="select_field relative">
                            <select
                              value={this.state.selectedSubtitleTab}
                              onChange={this.onSubtitleTabSelect}
                            >
                              {SUBTITLE_TABS.map(tab => (
                                <option key={tab.value} value={tab.value}>{tab.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>{(SUBTITLE_TABS.find(t => t.value === this.state.selectedSubtitleTab) || {}).name}</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name={this.state.selectedSubtitleTab}
                              editorState={this.state[this.state.selectedSubtitleTab]}
                              value={this.state[this.state.selectedSubtitleTab]}
                              onEditorStateChange={this.onSubtitleEditorChange}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Ticker 1</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="ticket1"
                              editorState={this.state.ticket1}
                              value={this.state.ticket1}
                              onEditorStateChange={e => this.onEditorStateChangeTickerOne(e)}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Ticker 2</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="ticket2"
                              editorState={this.state.ticket2}
                              value={this.state.ticket2}
                              onEditorStateChange={e => this.onEditorStateChangeTickerTwo(e)}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Ticker 3</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="ticket3"
                              editorState={this.state.ticket3}
                              value={this.state.ticket3}
                              onEditorStateChange={e => this.onEditorStateChangeTickerThree(e)}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Footer Subtitle</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="footerSubtitle"
                              editorState={this.state.footerSubtitle}
                              value={this.state.footerSubtitle}
                              onEditorStateChange={e => this.onEditorStateFooterSubtitleChange(e)}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{flex: '1 1'}}>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Add to Cart - In Person Content</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="addToCartInPersonContent"
                              editorState={this.state.addToCartInPersonContent}
                              value={this.state.addToCartInPersonContent}
                              onEditorStateChange={e => this.onEditorStateChangeAddToCartInPersonContent(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Add to Cart - Online Content</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="addToCartOnlineContent"
                              editorState={this.state.addToCartOnlineContent}
                              value={this.state.addToCartOnlineContent}
                              onEditorStateChange={e => this.onEditorStateChangeAddToCartOnlineContent(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Add to Cart Gala Content</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="addToCartGalaContent"
                              editorState={this.state.addToCartGalaContent}
                              value={this.state.addToCartGalaContent}
                            z  onEditorStateChange={e => this.onEditorStateChangeAddToCartGalaContent(e)}
                              height={'150'}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Add to Cart - Disclaimer</label>
                          <div className="field_input relative editor_wrapper">
                            <TextEditor
                              name="addToCartDisclaimer"
                              editorState={this.state.addToCartDisclaimer}
                              value={this.state.addToCartDisclaimer}
                              onEditorStateChange={e => this.onEditorStateChangeAddToCartDisclaimer(e)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text_center field_row w_100 buttons_outer">
                      <button className="uppercase" onClick={this.cancelBTN}>
                        CANCEL
                      </button>
                      <button disabled={this.state.loaderFlag || (this.state.id ? !this.state.isticketingEdited : false)} className={`uppercase ${this.state.loaderFlag || (this.state.id ? !this.state.isticketingEdited : false) ? '' : 'active'}`} type="button" onClick={e => this.submitFn(e)}>
                        SAVE
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {this.state.activetab === 1 ? <TicketingCart /> : ""}
          {this.state.activetab === 2 ? <TicketingFaq ref={this.childRef} /> : ""}
          {this.state.activetab === 3 ? <ContactUs /> : ""}
          
        </div>

        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
